import Tooltip from 'components/Tooltip';
import React from 'react';
import { Badge, Button } from 'reactstrap';

import styles from './styles.module.css';

interface SelectedFilterBadgeProps {
  label: string;
  values: string[];
  onRemove: () => void;
}

const SelectedFilterBadge: React.FC<SelectedFilterBadgeProps> = ({
  label,
  values,
  onRemove,
}) => {
  const firstValue =
    values[0]?.slice(0, 15) + (values[0]?.length > 15 ? '...' : '');
  const additionalCount = values.length - 1;

  const tooltipContent = (
    <div style={{ textAlign: 'left' }}>
      {values.map((value, index) => (
        <div key={index}>{value}</div>
      ))}
    </div>
  );

  return (
    <div className={`${styles.filterBadgeWrapper} position-relative mr-1 my-1`}>
      <Badge
        key={label}
        color="custom"
        className="d-flex align-items-center h-100"
      >
        <div className={`label px-1 py-2 ${styles.label}`}>{label}</div>
        <div
          className={`value px-1 py-2 h-100 d-flex align-items-center ${styles.value}`}
        >
          <Tooltip
            id={`filter-badge-tt-${label}`}
            title={label}
            tooltip={tooltipContent}
          >
            {firstValue}
            {additionalCount > 0 && (
              <Badge color="primary" pill className="ml-1">
                +{additionalCount}
              </Badge>
            )}
          </Tooltip>
        </div>
        <Tooltip
          id={`filter-badge-tt-remove-${label}`}
          title={label}
          tooltip="Click to reset this filter"
        >
          <Button
            color="danger"
            close
            className={`${styles.removeButton} position-absolute`}
            onClick={onRemove}
          />
        </Tooltip>
      </Badge>
    </div>
  );
};

export default SelectedFilterBadge;
